import { ProgressBlockTier } from './progress-block-tier.component';

export default ProgressBlockTier;
